import styled from 'styled-components'

//collapsed:

export const MentalStateCollapsedItemContainer = styled.div`
  background: ${({ mentalStateColor }) => (mentalStateColor ? mentalStateColor : '#35178e')};
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12), 0 1px 3px rgba(0, 0, 0, 0.08);
  width: calc(50% - 10px);
  min-width: 140px;
  max-width: 190px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 6px;
  padding: 14px 10px;
  cursor: pointer;
  border-radius: 14px;
  color: #fff;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border: 1px solid rgba(255, 255, 255, 0.12);
  -webkit-tap-highlight-color: transparent;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18), 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  @media (min-width: 480px) {
    width: 160px;
    min-width: unset;
    max-width: unset;
  }
  @media (min-width: 768px) {
    width: 190px;
    border-radius: 20px;
    gap: 8px;
    padding: 20px 16px;
  }
`

export const MentalStateCollapsedContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
  justify-content: center;

  @media (min-width: 768px) {
    gap: 20px;
  }
`

//expanded:

export const MentalStateExpandedContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 14px;
  margin-bottom: 24px;
  overflow: hidden;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.12);

  @media (min-width: 768px) {
    flex-direction: row;
    border-radius: 20px;
  }
`

export const MentalStateExpandedIndexContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  background: #200769;
  padding: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  flex-shrink: 0;

  ::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 768px) {
    flex-direction: column;
    width: 20%;
    max-height: 700px;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 35px 0 35px 35px;
    gap: 35px;
  }
`

export const MentalStateExpandedGraphContainer = styled.div`
  width: 100%;
  background: #e3ebff;
  box-shadow: rgb(255 255 255 / 37%) -1px 0px 15px 2px;
  padding: 16px;
  padding-bottom: 56px;
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 24px;
  min-width: 0;

  @media (min-width: 768px) {
    padding: 35px 35px 80px 35px;
    width: 80%;
    gap: 55px;
  }
`
// index expanded

function getExpandedIndexItemColor(props) {
  if (props?.selected) {
    return '#200769'
  } else {
    return props?.mentalStateColor ? props?.mentalStateColor : '#35178E'
  }
}

export const MentalStateExpandedIndexItemContainer = styled.div`
  background: ${(props) => (props?.selected ? '#e3ebff' : getExpandedIndexItemColor(props))};
  ${(props) => props?.selected && `box-shadow: rgb(255 255 255 / 37%) -1px 0px 15px 2px`};
  width: 100%;
  min-width: 80px;
  flex-shrink: 0;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 4px;
  padding: 10px 8px;
  cursor: pointer;
  border-radius: 12px;
  color: ${(props) => (props?.selected ? '#200769' : '#FFF')};
  -webkit-tap-highlight-color: transparent;

  @media (min-width: 768px) {
    min-width: unset;
    border-radius: 24px 0 0 24px;
    gap: 7px;
  }
`

export const MentalStateExpandedIndexItemImage = styled.img`
  width: 25px;
  aspect-ratio: 1;
  object-fit: contain;
  @media (min-width: 768px) {
    width: 47px;
  }
`

export const MentalStateExpandedIndexItemAverageScore = styled.span`
  color: ${(props) => (props?.goodScore ? '#59FFB3' : '#FF9D87')};
  ${(props) => props?.selected && `color: #200769`};
  font-size: 16px;
  font-weight: 700;
  @media (min-width: 768px) {
    font-size: 31px;
  }
`

export const MentalStateExpandedIndexItemMaxScore = styled.span`
  color: #5c37cb;
  font-size: 11px;
  font-weight: 500;
  @media (min-width: 768px) {
    font-size: 18px;
  }
`
// bargraph part

export const BarGraphHeader = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 4px;
  flex-wrap: wrap;
  @media (min-width: 768px) {
    flex-direction: row;
    gap: 0;
  }
`

export const MentalStateBarGraphTitle = styled.div`
  color: #200769;
  font-size: 17px;
  font-weight: 600;
  @media (min-width: 768px) {
    font-size: 27px;
    font-weight: 600;
    width: 230px;
  }
`

export const GlobalScoreContainer = styled.div`
  background: #0e121f;
  color: #fff;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 10px;
  cursor: default;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (min-width: 768px) {
    font-size: 16px;
    border-radius: 11px;
    padding: 8px 18px;
  }
`

export const TimeDurationButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #0f1322;
  width: 120px;
  cursor: pointer;
  color: #fff;
  padding: 8px 12px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
  transition: background 0.2s, transform 0.15s;

  &:hover {
    background: #1a1f33;
  }

  @media (min-width: 768px) {
    padding: 10px 16px;
    width: 150px;
    border-radius: 12px;
    font-size: 14px;
  }
`

export const MentalStateBarGraphStatContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media (min-width: 768px) {
    flex-direction: row;
    gap: 30px;
  }
`

export const MentalStateBarGraphStatName = styled.div`
  width: 90px;
  min-width: 0;
  color: #616161;
  font-size: 11px;
  font-weight: 400;
  flex-shrink: 0;

  @media (min-width: 480px) {
    width: 110px;
    font-size: 12px;
  }
  @media (min-width: 768px) {
    width: 120px;
    font-size: 16px;
  }
`

export const GraphLinesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  justify-content: center;
`

export const BarGraphLineContainer = styled.div`
  height: 7px;
  width: ${(props) => `${props?.value}%`};
  background: #39f;
  border-radius: 2px;
  position: relative;
  align-items: center;
  display: flex;
  justify-content: right;
  transition: all 0.3s ease-in-out;
  @media (min-width: 768px) {
    height: 10px;
    border-radius: 5px;
  }
`

export const BarGraphMaxScoreLine = styled.div`
  width: 100%;
  height: 1px;
  background: #dcdcdc;
`

export const BarGraphLineContainerWorld = styled.div`
  height: 7px;
  width: ${(props) => `${props?.value}%`};
  background: #ca98ff;
  border-radius: 2px;
  position: relative;
  display: flex;
  justify-content: right;
  align-items: center;
  transition: all 0.3s ease-in-out;
  @media (min-width: 768px) {
    height: 10px;
    border-radius: 5px;
  }
`

export const LegendsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 10px;
  left: 0;
  gap: 27px;
  @media (min-width: 768px) {
    bottom: 20px;
  }
`

export const BarGraphLineImage = styled.img`
  width: 20px;
  height: 20px;
  position: relative;
  object-fit: contain;
  left: 9px;
  padding: 2px;
  background: #3299ff;
  border-radius: 50px;
  ${(props) => (props?.top ? `bottom: 6px;` : `top: 6px;`)};
  ${(props) => props?.globe && `background: #CA98FF;`};
  @media (min-width: 768px) {
    padding: 4px;
    width: 35px;
    height: 35px;
    left: 12.5px;
    ${(props) => (props?.top ? `bottom: 12.5px;` : `top: 12.5px;`)};
  }
`
export const StyledDeltaImage = styled.img`
  width: 20px;
  height: 20px;
`
